<template>
  <Header />
  <Herosection />
  <VaticanNews />
  <Footer />
</template>

<script>
import Header from "@/components/Header.vue";
import Herosection from "@/components/HeroSectionPage.vue";
import Footer from "@/components/Footer.vue";
import VaticanNews from "@/components/views/VaticanNews.vue";

export default {
  components: {
    Header,
    Herosection,
    Footer,
    VaticanNews,
  },
};
</script>
